var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"border border-info bg-white rounded p-3"},[(_vm.setting.appId !== 'boston')?_c('FormSelect',{attrs:{"label":"フォント:","options":_vm.option.fontfamily},model:{value:(_vm.fontfamily),callback:function ($$v) {_vm.fontfamily=$$v},expression:"fontfamily"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }